import Box from "@mui/material/Box";
import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import { styles } from "./styles";
import { formStyles } from "./addUserStyles";
import Loader from "components/loader";
import React, { useState } from "react";
import { AddNewUser, getUserListing } from "./action";
import ROUTE_NAMES from "routes/routeNames";
import { ReducersModal } from "utils/modals";
import { useNavigate } from "react-router-dom";
import { createUserSchema } from "utils/schema";
import UserDopdown from "components/userDropdown";
import { USER_ROLE, USER_TYPE, getUserRoleLabel } from "utils/userType";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_USER_REDUCER } from "store/actionTypes";
import { UPLOAD_FILE_TO_S3 } from "utils/services";
import { getCarCompanyList } from "modules/company/action";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { APIResponseModal, UserDetailModal } from "utils/modals";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { FOLDER } from "utils/constants";

const FormSection = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <Box sx={formStyles.section}>
    <Typography component="h2" sx={formStyles.sectionTitle}>
      {title}
    </Typography>
    <Box sx={formStyles.grid}>{children}</Box>
  </Box>
);

export default function AddUser() {
  const { result } = useSelector((state: ReducersModal) => state.UserReducer);

  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const initialState: any = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    profilePhoto: "",
    password: "Admin@123",
    confirmPassword: "Admin@123",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pincode: "",
    gstNumber: "",
    document: "",
    salary: 0,
    dateOfJoining: "",
    registrationNumber: "",
    franchiseAmount: "",
    numberOfStaff: 0,
    country: "India",
    role: USER_ROLE.COORDINATOR,
    vendorId: "",
  };

  const handleOnSubmit = (values: any) => {
    setLoading(true);
    dispatch(
      AddNewUser(values, ({ isSuccess, data }: APIResponseModal) => {
        if (isSuccess) {
          navigate(`${ROUTE_NAMES.MAIN_ROUTES.EDIT_USER}?id=${data?._id}`);
        }
        setLoading(false);
      })
    );
  };

  React.useEffect(() => {
    dispatch(getCarCompanyList(() => { }));
    // dispatch(getVehicleList(() => {},{companyId:7}));
  }, [dispatch]);
  const formatNumber = (phNumber: string) => {
    let input = phNumber.replace(/\D/g, "");
    return input;
  };

  const startDocumentUpload = async (file: File, callback: Function) => {
    setLoading(true);
    try {
      const documentUrl = await UPLOAD_FILE_TO_S3(file, FOLDER.USER_DOCUMENT);
      callback(documentUrl);
      setDocLink(documentUrl);
    } catch (err: any) {
    } finally {
      setLoading(false);
    }
    // setLoading(true);
    // const formdata = new FormData();
    // formdata.append("file", file);
    // dispatch(
    //   requestFileUpload(formdata, (resp: APIResponseModal) => {
    //     if (resp.isSuccess) {
    //       setLoading(false);
    //       callback(resp);
    //       setDocLink(resp?.data?.imageUrl);
    //     } else {
    //       setLoading(false);
    //     }
    //   })
    // );
  };

  const [docLink, setDocLink] = useState("");
  const onDocumentPicked = (
    evt: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: Function
  ) => {
    if (
      evt &&
      evt?.target &&
      evt?.target?.files &&
      evt?.target?.files?.length > 0
    ) {
      const file = evt.target.files[0];
      startDocumentUpload(file, (resp: any) => {
        setFieldValue("document", resp);
      });
    }
  };
  const docRef = React.useRef<HTMLInputElement>(null);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };

  const onUploadDocumentClick = () => {
    docRef.current?.click();
  };

  const dispatchValue = (payload: any) => {
    dispatch({
      type: UPDATE_USER_REDUCER,
      payload,
    });
  };

  const getVendorList = () => {
    dispatchValue({
      limit: 100,
      page: 1,
      result: [],
      userType: USER_TYPE.MERCHANT,
    });
    dispatch(getUserListing());
  };

  return (
    <Formik
      onSubmit={handleOnSubmit}
      initialValues={initialState}
      validationSchema={createUserSchema}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
        setFieldValue,
      }      ) => (
        <Box component="form" noValidate onSubmit={handleSubmit} sx={formStyles.card}>
          <FormSection title="Account">
              <FormControl fullWidth>
                <InputLabel>{"User Type"}</InputLabel>
                <Select
                  label="User Type"
                  name="role"
                  native={false}
                  variant="outlined"
                  value={values.role}
                  onChange={(e: any) => {
                    // Service partners are linked to a franchise
                    if (e.target.value === USER_ROLE.SERVICE_PARTNER)
                      getVendorList();
                    setFieldValue("role", e.target.value);
                  }}
                >
                  <MenuItem value={USER_ROLE.COORDINATOR}>
                    {getUserRoleLabel(USER_ROLE.COORDINATOR)}
                  </MenuItem>
                  <MenuItem value={USER_ROLE.MERCHANT}>
                    {getUserRoleLabel(USER_ROLE.MERCHANT)}
                  </MenuItem>
                  <MenuItem value={USER_ROLE.SERVICE_PARTNER}>
                    {getUserRoleLabel(USER_ROLE.SERVICE_PARTNER)}
                  </MenuItem>
                  <MenuItem value={USER_ROLE.CUSTOMER}>
                    {getUserRoleLabel(USER_ROLE.CUSTOMER)}
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-firstName-field">
                  {"First name"}
                </InputLabel>
                <OutlinedInput
                  type="text"
                  name="firstName"
                  label="firstName"
                  disabled={false}
                  id="as-firstName-field"
                  value={values.firstName}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.firstName && errors.firstName && (
                  <FormHelperText error id="as-helper-firstName">
                    {errors?.firstName?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-lastName-field">
                  {"Last name"}
                </InputLabel>
                <OutlinedInput
                  type="text"
                  name="lastName"
                  label="lastName"
                  disabled={false}
                  id="as-lastName-field"
                  value={values.lastName}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.lastName && errors.lastName && (
                  <FormHelperText error id="as-helper-lastName">
                    {errors?.lastName?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-email-field">
                  {"Email Address"}
                </InputLabel>
                <OutlinedInput
                  type="email"
                  name="email"
                  label="Email Address"
                  disabled={false}
                  id="as-email-field"
                  value={values.email}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.email && errors.email && (
                  <FormHelperText error id="as-helper-email">
                    {errors?.email?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-mobile-field" shrink={true}>
                  {"Mobile Number"}
                </InputLabel>
                <OutlinedInput
                  type="text"
                  name="phoneNumber"
                  onBlur={handleBlur}
                  id="as-mobile-field"
                  label="Mobile Number"
                  value={formatNumber(values.phoneNumber)}
                  onChange={(e: any) => {
                    if (e.target.value.length <= 10) {
                      setFieldValue(
                        "phoneNumber",
                        formatNumber(e.target.value)
                      );
                    } else {
                      return;
                    }
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <Typography sx={formStyles.prefix}>{"+91"}</Typography>
                    </InputAdornment>
                  }
                />
                {touched.phoneNumber && errors.phoneNumber && (
                  <FormHelperText error id="as-helper-mobile">
                    {errors.phoneNumber.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-password-field">
                  {"Password"}
                </InputLabel>
                <OutlinedInput
                  name="password"
                  label="Password"
                  disabled={false}
                  id="as-password-field"
                  value={values.password}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Show password"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        sx={formStyles.adornmentButton}
                      >
                        {showPassword ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {touched.password && errors.password && (
                  <FormHelperText error id="as-helper-password">
                    {errors?.password?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-confirmPassword-field">
                  {"Confirm Password"}
                </InputLabel>
                <OutlinedInput
                  name="confirmPassword"
                  label="confirmPassword"
                  disabled={false}
                  id="as-confirmPassword-field"
                  value={values.confirmPassword}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type={showConfirmPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Show confirm password"
                        onClick={handleClickShowConfirmPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        sx={formStyles.adornmentButton}
                      >
                        {showConfirmPassword ? (
                          <VisibilityOutlined />
                        ) : (
                          <VisibilityOffOutlined />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {touched.confirmPassword && errors.confirmPassword && (
                  <FormHelperText error id="as-helper-confirmPassword">
                    {errors?.confirmPassword?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
          </FormSection>

          <FormSection title="Address">
              <FormControl fullWidth>
                <InputLabel htmlFor="as-addressLine1-field">
                  {"Address Line1"}
                </InputLabel>
                <OutlinedInput
                  type="text"
                  name="addressLine1"
                  label="addressLine1"
                  disabled={false}
                  id="as-addressLine1-field"
                  value={values.addressLine1}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.addressLine1 && errors.addressLine1 && (
                  <FormHelperText error id="as-helper-addressLine1">
                    {errors?.addressLine1?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-addressLine2-field">
                  {"Address Line2"}
                </InputLabel>
                <OutlinedInput
                  type="text"
                  name="addressLine2"
                  label="addressLine2"
                  disabled={false}
                  id="as-addressLine2-field"
                  value={values.addressLine2}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.addressLine2 && errors.addressLine2 && (
                  <FormHelperText error id="as-helper-addressLine2">
                    {errors?.addressLine2?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-city-field">{"City"}</InputLabel>
                <OutlinedInput
                  type="text"
                  name="city"
                  label="City"
                  disabled={false}
                  id="as-city-field"
                  value={values.city}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.city && errors.city && (
                  <FormHelperText error id="as-helper-city">
                    {errors?.city?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-state-field">{"State"}</InputLabel>
                <OutlinedInput
                  type="text"
                  name="state"
                  label="State"
                  disabled={false}
                  id="as-state-field"
                  value={values.state}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {touched.state && errors.state && (
                  <FormHelperText error id="as-helper-cstateity">
                    {errors?.state?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth>
                <InputLabel htmlFor="as-pinCode-field">{"Pin Code"}</InputLabel>
                <OutlinedInput
                  sx={styles.removeArrow}
                  type="number"
                  name="pincode"
                  label="PinCode"
                  disabled={false}
                  id="as-pinCode-field"
                  value={values.pincode}
                  onBlur={handleBlur}
                  onChange={(e: any) => {
                    if (e.target.value.length <= 6) {
                      setFieldValue("pincode", e.target.value);
                    } else {
                      return;
                    }
                  }}
                />
                {touched.pincode && errors.pincode && (
                  <FormHelperText error id="as-helper-pinCode">
                    {errors?.pincode?.toString()}
                  </FormHelperText>
                )}
              </FormControl>
          </FormSection>

          {values.role !== USER_ROLE.CUSTOMER && (
            <FormSection title="Work details">
            {values.role === USER_ROLE.MERCHANT && (
                <FormControl fullWidth>
                  <InputLabel htmlFor="as-gstNumber-field">
                    {"GST Number"}
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    name="gstNumber"
                    label="GST Number"
                    disabled={false}
                    id="as-gstNumber-field"
                    value={values.gstNumber}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                  {touched.gstNumber && errors.gstNumber && (
                    <FormHelperText error id="as-helper-gstNumber">
                      {errors?.gstNumber?.toString()}
                    </FormHelperText>
                  )}
                </FormControl>
            )}
            {(values.role === USER_ROLE.COORDINATOR || values.role === USER_ROLE.SERVICE_PARTNER) && (
                <FormControl fullWidth>
                  <InputLabel htmlFor="as-document-field">
                    {"Document"}
                  </InputLabel>
                  <OutlinedInput
                    sx={formStyles.uploadField}
                    label="Document"
                    type="text"
                    name="document"
                    disabled={false}
                    id="as-document-field"
                    value={values.document || docLink}
                    onBlur={handleBlur}
                    onClick={onUploadDocumentClick}
                    onChange={handleChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton edge="end" aria-label="Upload document" sx={formStyles.adornmentButton}>
                          <UploadFileOutlinedIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <input
                    id="docInput"
                    type="file"
                    ref={docRef}
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    style={{ display: "none" }}
                    onChange={(e) => onDocumentPicked(e, setFieldValue)}
                  />
                  {touched.document && errors.document && !docLink && (
                    <FormHelperText error id="as-helper-document">
                      {errors?.document?.toString()}
                    </FormHelperText>
                  )}
                </FormControl>
            )}
            {(values.role === USER_ROLE.COORDINATOR || values.role === USER_ROLE.SERVICE_PARTNER) && (
                <FormControl fullWidth>
                  <InputLabel htmlFor="as-salary-field">{"Salary"}</InputLabel>
                  <OutlinedInput
                    sx={styles.removeArrow}
                    startAdornment={
                      <InputAdornment position="start">
                        <CurrencyRupeeIcon sx={formStyles.rupee} />
                      </InputAdornment>
                    }
                    type="number"
                    name="salary"
                    label="Salary"
                    disabled={false}
                    id="as-salary-field"
                    value={values.salary}
                    onBlur={handleBlur}
                    onChange={(e: any) => {
                      let value = Number(e.target.value);
                      if (value <= 1000000 && value >= 0) {
                        setFieldValue("salary", e.target.value);
                      } else {
                        return;
                      }
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.code === "KeyE" ||
                        e.code === "Minus" ||
                        e.code === "Space"
                      )
                        e.preventDefault();
                    }}
                  />
                  {touched.salary && errors.salary && (
                    <FormHelperText error id="as-helper-salary">
                      {errors?.salary?.toString()}
                    </FormHelperText>
                  )}
                </FormControl>
            )}
            {(values.role === USER_ROLE.COORDINATOR ||
              values.role === USER_ROLE.MERCHANT ||
              values.role === USER_ROLE.SERVICE_PARTNER) && (
                  <FormControl fullWidth>
                    <TextField
                      type="date"
                      name="dateOfJoining"
                      label="Date of joining"
                      disabled={false}
                      id="as-dateOfJoining-field"
                      value={values.dateOfJoining}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                    />
                    {touched.dateOfJoining && errors.dateOfJoining && (
                      <FormHelperText error id="as-helper-dateOfJoining">
                        {errors?.dateOfJoining?.toString()}
                      </FormHelperText>
                    )}
                  </FormControl>
              )}
            {values.role === USER_ROLE.MERCHANT && (
                <FormControl fullWidth>
                  <InputLabel htmlFor="as-registrationNumber-field">
                    {"Registration Number"}
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    name="registrationNumber"
                    label="Registration Number"
                    disabled={false}
                    id="as-registrationNumber-field"
                    value={values.registrationNumber}
                    onBlur={handleBlur}
                    onChange={(e: any) => {
                      if (e.target.value.length <= 10) {
                        setFieldValue("registrationNumber", e.target.value);
                      } else {
                        return;
                      }
                    }}
                  />
                  {touched.registrationNumber && errors.registrationNumber && (
                    <FormHelperText error id="as-helper-registrationNumber">
                      {errors?.registrationNumber?.toString()}
                    </FormHelperText>
                  )}
                </FormControl>
            )}
            {values.role === USER_ROLE.MERCHANT && (
                <FormControl fullWidth>
                  <InputLabel htmlFor="as-franchiseAmount-field">
                    {"Franchise Amount"}
                  </InputLabel>
                  <OutlinedInput
                    sx={styles.removeArrow}
                    type="number"
                    name="franchiseAmount"
                    label="Franchise Amount"
                    disabled={false}
                    id="as-franchiseAmount-field"
                    value={values.franchiseAmount}
                    onBlur={handleBlur}
                    onChange={(e: any) => {
                      setFieldValue("franchiseAmount", e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.code === "KeyE" ||
                        e.code === "Minus" ||
                        e.code === "Space"
                      )
                        e.preventDefault();
                    }}
                  />
                  {touched.franchiseAmount && errors.franchiseAmount && (
                    <FormHelperText error id="as-helper-franchiseAmount">
                      {errors?.franchiseAmount?.toString()}
                    </FormHelperText>
                  )}
                </FormControl>
            )}
            {values.role === USER_ROLE.MERCHANT && (
                <FormControl fullWidth>
                  <InputLabel htmlFor="as-numberOfStaff-field">
                    {"Number of Service Partner"}
                  </InputLabel>
                  <OutlinedInput
                    sx={styles.removeArrow}
                    type="number"
                    name="numberOfStaff"
                    label="Number of Service Partner"
                    disabled={false}
                    id="as-numberOfStaff-field"
                    value={values.numberOfStaff}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      if (
                        e.code === "KeyE" ||
                        e.code === "Minus" ||
                        e.code === "Space"
                      )
                        e.preventDefault();
                    }}
                  />
                  {touched.numberOfStaff && errors.numberOfStaff && (
                    <FormHelperText error id="as-helper-numberOfStaff">
                      {errors?.numberOfStaff?.toString()}
                    </FormHelperText>
                  )}
                </FormControl>
            )}

            {values.role === USER_ROLE.SERVICE_PARTNER && result?.length > 0 && (
                <FormControl fullWidth>
                  <UserDopdown
                    userType={USER_TYPE.MERCHANT}
                    onSelectUser={(user: UserDetailModal | null) => {
                      const merchantId = user?.id || (user as any)?._id || "";
                      setFieldValue("vendorId", merchantId);
                    }}
                  />
                  {touched.vendorId && errors.vendorId && (
                    <FormHelperText error id="as-helper-vendorId">
                      {errors?.vendorId?.toString()}
                    </FormHelperText>
                  )}
                </FormControl>
            )}
            </FormSection>
          )}
          <Box sx={formStyles.footer}>
            <Button type="submit" variant="contained" sx={formStyles.submit}>
              Create New User
            </Button>
          </Box>
          {loading && <Loader />}
        </Box>
      )}
    </Formik>
  );
}
